export interface WordTerm { term: string; count: number }
export type LaidOutTerm = WordTerm & { size: number; color: string };

const MIN_PX = 12;
const MAX_PX = 40;
// Tons do mockup (roxo, ardósia, laranja, vermelho, azul, marinho) escurecidos para contraste >= 4.5:1 em fundo branco;
// o ciano e o âmbar de SERIES_COLORS ficam de fora porque texto pequeno neles some.
export const WORD_COLORS = ["#6b46c1", "#475569", "#b45309", "#b42318", "#0b6fb0", "#17384c"];

export function fontSizeFor(count: number, min: number, max: number): number {
  if (max <= min) return Math.round((MIN_PX + MAX_PX) / 2);
  const t = (Math.log(count) - Math.log(min)) / (Math.log(max) - Math.log(min));
  return Math.round(MIN_PX + t * (MAX_PX - MIN_PX));
}

// Ordena por contagem (desempate alfabético), corta em `limit` e calcula tamanho/cor de cada termo.
export function layoutTerms(terms: WordTerm[], limit = 40): LaidOutTerm[] {
  const sorted = terms.filter((t) => t.count > 0).sort((a, b) => b.count - a.count || a.term.localeCompare(b.term, "pt-BR")).slice(0, limit);
  if (sorted.length === 0) return [];
  const max = sorted[0].count;
  const min = sorted[sorted.length - 1].count;
  return sorted.map((t, i) => ({ ...t, size: fontSizeFor(t.count, min, max), color: WORD_COLORS[i % WORD_COLORS.length] }));
}
